import type {columnResizingState as ColumnResizingState, OnChangeFn} from '@tanstack/react-table'
import {useCallback, useState} from 'react'

import {MIN_CELL_WIDTH} from '../../../components/table/constants'
import {parseColumnId} from '../../../helpers/parsing'
import {useColumnWidth} from '../../../state-providers/columns/use-column-width'

const initialColumnResizingState: ColumnResizingState = {
  isResizingColumn: false,
  startOffset: null,
  startSize: null,
  deltaOffset: null,
  deltaPercentage: null,
  columnSizingStart: [],
}

export const useColumnResizing = () => {
  const {updateWidth} = useColumnWidth()
  const [columnResizing, setColumnResizing] = useState<ColumnResizingState>(initialColumnResizingState)

  const onColumnResizingChange: OnChangeFn<ColumnResizingState> = useCallback(
    updater => {
      const newState = typeof updater === 'function' ? updater(columnResizing) : updater
      const previousResizingColumnId = columnResizing.isResizingColumn

      // Persist the column width when resizing stops.
      if (previousResizingColumnId && !newState.isResizingColumn && columnResizing.startSize !== null) {
        const columnModelId = parseColumnId(previousResizingColumnId)
        // The persisted width must never be less than MIN_CELL_WIDTH.
        const finalSize = Math.max(columnResizing.startSize + (columnResizing.deltaOffset ?? 0), MIN_CELL_WIDTH)

        if (columnModelId) updateWidth(columnModelId, finalSize)
      }

      setColumnResizing(newState)
    },
    [columnResizing, updateWidth],
  )

  return {columnResizing, onColumnResizingChange}
}
